module.exports = __webpack_public_path__ + "img/lane-changing_map.f419d2b0.svg";